export default {
  clickedButtonMenu_academy: 'clickedButtonMenu_dgfzAcademy',
  clickedButtonMenu_webinar: 'clickedButtonMenu_webinar',
  clickedButtonMenu_referAndEarn: 'clickedButtonMenu_dgfzReferAndEarn',
  clickedButtonMenu_faq: 'clickedButtonMenu_FAQ',
  clickedButtonMenu_newContract: 'clickedButtonMenu_newContract',
  clickedButtonMenu_userManagement: 'clickedButtonMenu_userManagement',
}
